import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { DeclineRecalculationResultCode, TransactionUpdateResult } from "../transaction.model";

@Component({
    selector: 'ifb-transaction-declined-dialog',
    templateUrl: './transaction-declined-dialog.component.html',
    styleUrls: ['./transaction-declined-dialog.component.scss'],
    standalone: false
})
export class TransactionDeclinedDialogComponent {

  readonly DeclineRecalculationResultCode = DeclineRecalculationResultCode;
  updateResult: TransactionUpdateResult;
  tableData: any;
  displayedColumns: string[] = ['label', 'oldValue', 'newValue'];

  constructor(public dialogRef: MatDialogRef<TransactionDeclinedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.updateResult = this.data.transactionUpdateResult;
    this.tableData = [
    {
      label: 'Principal balance',
      oldValue: this.updateResult.previousLoan.currentState.principalBalance,
      newValue: this.updateResult.currentLoan.currentState.principalBalance,
    },
    {
      label: 'Accrued interest',
      oldValue: this.updateResult.previousLoan.currentState.accruedInterest,
      newValue: this.updateResult.currentLoan.currentState.accruedInterest,
    },
    {
      label: 'Total interest',
      oldValue: this.updateResult.previousLoan.currentState.totalInterestCharged,
      newValue: this.updateResult.currentLoan.currentState.totalInterestCharged,
    },
    {
      label: 'Total interest paid',
      oldValue: this.updateResult.previousLoan.currentState.totalInterestPaid,
      newValue: this.updateResult.currentLoan.currentState.totalInterestPaid,
    },
    {
      label: 'Total principal paid',
      oldValue: this.updateResult.previousLoan.currentState.totalPrincipalPaid,
      newValue: this.updateResult.currentLoan.currentState.totalPrincipalPaid,
    },
  ];
  }

  static show(dialog: MatDialog, transactionUpdateResult: TransactionUpdateResult): Observable<any> {
    return dialog.open(TransactionDeclinedDialogComponent, {
      width: '600px',
      data: {
        transactionUpdateResult: transactionUpdateResult
      },
      closeOnNavigation: true,
    }).afterClosed();
  }

  onActionClicked(): void {
    this.dialogRef.close();
  }
}
